import { render } from "./CreateKingdom.vue?vue&type=template&id=4ef91af0"
import script from "./CreateKingdom.vue?vue&type=script&lang=js"
export * from "./CreateKingdom.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/buildings/embassy/windowOverlay/CreateKingdom.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4ef91af0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4ef91af0', __exports__)) {
    api.reload('4ef91af0', __exports__)
  }
  
  module.hot.accept("./CreateKingdom.vue?vue&type=template&id=4ef91af0", () => {
    api.rerender('4ef91af0', render)
  })

}


export default __exports__